import Vue from 'vue';

import Bookmark from './Bookmark.vue';

new Vue({
	el: '#mArticle',
	render: h => h(Bookmark),
});
